const migrations = {
  0: (state) => {
    return {
      ...state,
      localStorage: {
        ...state.localStorage,
        tableStates: {},
      },
    };
  },
};

export default migrations;
